export default __webpack_public_path__ + "static/media/expo-logo-blue.c47e43cf.png";